export const Constants = {
  oversight: 'Proto Oversight',
  oversight_title_tooltip: 'Monitore sessões e acesso delegado',
  notifications: 'Notificações',
  notifications_open: 'Abrir notificações',
  notifications_close: 'Fechar notificações',
  notifications_search: 'Buscar por cliente ou data...',
  notifications_client: 'Cliente:',
  notifications_today: 'Hoje',
  notifications_yesterday: 'Ontem',
  notifications_empty: 'Nenhuma notificação encontrada.',
  notifications_load_more: 'Carregar mais',
  notifications_mark_as_read: 'Marcar como lida',
  new_user_add: 'adicionar usuário',
  new_user_name: 'nome completo',
  new_user_name_placeholder: 'digite o nome do usuário',
  new_user_email: 'e-mail',
  new_user_email_placeholder: 'digite o e-mail do usuário',
  new_user_role: 'tipo de usuário',
  new_user_role_placeholder: 'selecione',
  new_user_role_admin: 'Admin',
  new_user_role_supervisor: 'Supervisor',
  new_user_role_operator: 'Operador',
  new_user_role_auditor: 'Auditor',
  new_user_cancel: 'cancelar',
  new_user_save: 'salvar',
  new_user_success: 'Usuário adicionado com sucesso!',
};
